module.exports = __webpack_public_path__ + "static/media/unlink_on.77e507ea.png";